module.exports = __webpack_public_path__ + "collection-set-icon.png?5cfdfee2549c5e70374122a22163d28f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/collection-set-icon.png
// module id = 71
// module chunks = 0